// extracted by mini-css-extract-plugin
export default {"CounterSection":"CounterSection_CounterSection__WyLIF","counter":"CounterSection_counter__Ln0jZ","item":"CounterSection_item__6AsIM"};